import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useNotifications } from "../hooks/useNotifications";
import HamburgerMenu from "../Components/HamburgerMenu/HamburgerMenu";
import HamburgerButton from "../Components/HamburgerMenu/HamburgerButton";
import { ModalMessage } from "../Components/ModalMessage/ModalMessage";
import Footer from "../Components/Footer/Footer";
import NotificationCard from "../Components/NotificationCard/NotificationCard";
import "./NotificacoesPage.css";

const NotificacoesPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout: authLogout } = useAuth();
  const { fetchNotifications, notificationState, hasRecentNotifications } = useNotifications();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [showLogoutModal, setShowLogoutModal] = React.useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    authLogout();
    setShowLogoutModal(false);
  };

  // Buscar notificações quando o componente carregar
  useEffect(() => {
    if (isAuthenticated) {
      fetchNotifications();
    }
  }, [isAuthenticated, fetchNotifications]);

  return (
    <div className="notificacoes-page">
      <header className="page-header">
        <div className="header-content">
          <div className="header-left">
            {isAuthenticated && (
              <HamburgerButton 
                isOpen={isMenuOpen} 
                onClick={toggleMenu}
                hasNotification={hasRecentNotifications()}
              />
            )}
          </div>
          <div className="header-actions">
            <button
              onClick={
                isAuthenticated ? handleLogout : () => navigate("/login")
              }
              className="auth-button"
            >
              {isAuthenticated ? "Sair" : "Entrar"}
            </button>
          </div>
        </div>
      </header>

      {isAuthenticated && (
        <HamburgerMenu 
          isOpen={isMenuOpen} 
          onClose={closeMenu}
          hasRecentNotifications={hasRecentNotifications()}
        />
      )}

      <main className="page-main">
        <div className="page-title">
          <h1>Notificações</h1>
          <p>Suas notificações e atualizações</p>
        </div>

        <div className="notifications-mural">
          {notificationState.isLoading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <span>Carregando notificações...</span>
            </div>
          ) : notificationState.error ? (
            <div className="error-message">❌ {notificationState.error}</div>
          ) : notificationState.notifications.length === 0 ? (
            <div className="empty-notifications">
              <div className="empty-icon">🔔</div>
              <h3>Nenhuma notificação</h3>
              <p>Você não possui notificações no momento.</p>
            </div>
          ) : (
            <div className="notifications-grid">
              {notificationState.notifications.map((notification, index) => (
                <NotificationCard
                  key={notification.id}
                  id={notification.id}
                  title={notification.title}
                  message={notification.message}
                  createdAt={notification.createdAt}
                  imageUrl={notification.imageUrl}
                  cardIndex={index}
                  onClick={() => {}}
                />
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />

      {showLogoutModal && (
        <ModalMessage
          title="Tem certeza?"
          description="Deseja realmente sair da sua conta?"
          leftButtonText="Sim"
          leftButtonAction={confirmLogout}
          rightButtonText="Não"
          rightButtonAction={() => setShowLogoutModal(false)}
        />
      )}
    </div>
  );
};

export default NotificacoesPage;
